import styled from 'styled-components';

export const HorizontalFormFieldSC = styled.div<{
  haveLabel: boolean;
  disabled?: boolean;
}>`
  .content {
    display: flex;
    opacity: ${({ disabled }) => (disabled ? '0.5' : 1)};
  }

  .meta {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
  }

  .wrapped-comp {
    margin-left: ${({ haveLabel }) => (haveLabel ? '15px' : 0)};
    width: 100%;
  }
`;
